const TERMINAL_STATUSES = ['SUCCEEDED', 'CARD_VALIDATION_FAILED', 'CANCELED']
const ERROR_STATUSES = ['CARD_VALIDATION_FAILED', 'CANCELED']

export const derivePaymentView = (cartPayment, amount) => {
	const {
		terminalPaymentSession,
		terminalPaymentSessionInvalid,
		terminalProcessError,
		tap2PayPaymentSession,
		tap2PayPaymentSessionInvalid,
		tap2PayCreateSessionError,
		qrCodePaymentSession,
	} = cartPayment

	if (
		terminalPaymentSessionInvalid ||
		terminalProcessError ||
		(terminalPaymentSession && ERROR_STATUSES.includes(terminalPaymentSession.status))
	) {
		return { status: 'FAILED', method: 'TERMINAL' }
	}

	if (
		terminalPaymentSession &&
		!TERMINAL_STATUSES.includes(terminalPaymentSession.status)
	) {
		return { status: 'WAITING', method: 'TERMINAL' }
	}

	if (
		tap2PayPaymentSessionInvalid ||
		tap2PayCreateSessionError ||
		(tap2PayPaymentSession && ERROR_STATUSES.includes(tap2PayPaymentSession.status))
	) {
		return { status: 'FAILED', method: 'TAP2PAY' }
	}

	if (tap2PayPaymentSession?.status === 'SUCCEEDED') {
		return { status: 'SUCCESS', method: 'TAP2PAY' }
	}

	if (
		tap2PayPaymentSession &&
		!TERMINAL_STATUSES.includes(tap2PayPaymentSession.status)
	) {
		return { status: 'WAITING', method: 'TAP2PAY' }
	}

	if (qrCodePaymentSession?.link && qrCodePaymentSession.status === 'SUCCEEDED') {
		return { status: 'SUCCESS', method: 'QR' }
	}

	if (qrCodePaymentSession?.link && !TERMINAL_STATUSES.includes(qrCodePaymentSession.status)) {
		return { status: 'WAITING', method: 'QR', qrCodeLink: qrCodePaymentSession.link, ...(amount != null && { amount }) }
	}

	return { status: 'NONE' }
}
